// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimilarOpportunity_wrapper__2bAi5","title":"SimilarOpportunity_title__2ySW-","text":"SimilarOpportunity_text__1hpHj","link":"SimilarOpportunity_link__3lS5Y"};